import { TinyPopover, Toolbar } from '@octopus-do/octopus-storybook'
import { Sparkles } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { forwardRef } from 'react'

// Key the popover reports to Toolbar.Root; the submitted prompt follows it.
export const GENERATE_POPOVER_ID = 'generate'

const WIDTH = 216

const Content: React.FC = () => (
  <TinyPopover.PromptInput
    placeholder="A few words about page content..."
    submitLabel="Generate"
    variant="purple"
  />
)

interface TriggerProps {
  disabled: boolean
  loading: boolean
}

const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(
  ({ disabled, loading }, ref) => {
    const { active, toggle } = TinyPopover.useTrigger()

    return (
      <Toolbar.DropdownButton
        active={active}
        disabled={disabled}
        icon={Sparkles}
        loading={loading}
        onClick={toggle}
        ref={ref}
        tooltip="Generate blocks"
        variant="purple"
      />
    )
  }
)

interface Props {
  disabled: boolean
  // The assistant is generating: the button shows a loader until it is done
  loading: boolean
}

export const GeneratePopover: React.FC<Props> = ({ disabled, loading }) => {
  const { onClick } = Toolbar.useToolbarClick(GENERATE_POPOVER_ID)

  const onSubmit = (value: string) => onClick([value])

  return (
    <TinyPopover.Root content={Content} onSubmit={onSubmit} width={WIDTH}>
      <Trigger disabled={disabled} loading={loading} />
    </TinyPopover.Root>
  )
}
